import { Component, ElementRef, ViewChild, ViewEncapsulation, inject, OnInit, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-drawing-pad',
  templateUrl: './drawing-pad.component.html',
  styleUrl: './drawing-pad.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DrawingPadComponent implements OnInit, AfterViewInit {
    dialogRef = inject<MatDialogRef<DrawingPadComponent>>(MatDialogRef);
    data = inject<{
    padInfo;
}>(MAT_DIALOG_DATA);

    signaturePad!: SignaturePad;
    pad_height: number;
    pad_width: number;
    pad_data: string;
    public signatureImg!: string;
    @ViewChild('canvas') canvasEl!: ElementRef;
  
    constructor() {
      const data = this.data;
 
      this.pad_height = parseInt(data["pad_height"]);
      this.pad_width = parseInt(data["pad_width"]);
      this.pad_data = data["pad_data"];
    }
  
    ngOnInit(): void {
      
    }
    
    ngAfterViewInit() {
      this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
      if((this.pad_data??"") != ""){
        this.loadSignature(this.pad_data);
      }
    }
  
    clearPad() {
      this.signaturePad.clear();
    }

    isEmpty(){
        return this.signaturePad.isEmpty();
    }
  
    savePad() {
      if (!this.signaturePad.isEmpty()) {
        const base64Data = this.signaturePad.toDataURL();
        this.signatureImg = base64Data;
      }
      else{
        this.signatureImg = "";
      }
      this.closeDialog();
    }

    closeDialog() {
      this.dialogRef.close(true);
    }

    onChangeColor(){
      this.signaturePad.penColor = (document.querySelector(".penColor") as HTMLInputElement).value;
    }

    loadSignature(base64Data: string) {
      const canvas = this.canvasEl.nativeElement;
      const ctx = canvas.getContext('2d');
      const image = new Image();
      image.onload = () => {
        ctx?.clearRect(0, 0, canvas.width, canvas.height);
        ctx?.drawImage(image, 0, 0, canvas.width, canvas.height);
      };
      image.src = base64Data;
    }
}